import type { Id, Item } from './types'

export const retrieveItem = <T extends Item<Id>>(
  items: T[],
  id: T['id'],
): T | undefined => {
  return items.find((item) => item.id === id)
}
